<!-- <div class="row">
    <div class="col-1"></div>
    <div class="progressBar p-0" [ngClass]="{'col-3': windowWidth>768, 'col-6':windowWidth<=768}">
        <div *ngIf="progressBarData" class="progress progress-bar-striped progress-bar-animated" [ngClass]="{'progress-border-success': progressBarData.percentage === 100 ,'progress-border-start' : progressBarData.percentage < 100 }">
            <div *ngIf="progressBarData.percentage < 100" class="progress-bar progress-bar-inprogress" [ngStyle]="{'width': progressBarData.widthPercentage }"></div>
            <div *ngIf="progressBarData.percentage === 100" style="width:100%;" class="progress-bar progress-bar-completed">Success!</div>
        </div>

        <span class="d-flex">
            <span class="progress-text-start" *ngIf="progressBarData.percentage > 0 && progressBarData.percentage < 50">Start</span>
            <span class="progress-text-inprogress" *ngIf="progressBarData.percentage >= 50 && progressBarData.percentage < 100">Almost There</span>
            <span class="progress-text-completed" *ngIf="progressBarData.percentage === 100">Completed!</span>
        </span>
    </div>
</div> -->




<div *ngIf=" progressBarData" class="cts-progress-bar" [ngStyle]="{'width': progressBarData.widthPercentage}" [ngClass]="{'cts-progress-success': progressBarData.percentage === 100 ,'cts-progress-start' : progressBarData.percentage < 100 }"></div>